// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IDelinquentClaimsSummaryRecordDto } from './IDelinquentClaimsSummaryRecordDto';
import {
    IDelinquentClaimsSummaryRecordDtoFromJSON,
    IDelinquentClaimsSummaryRecordDtoFromJSONTyped,
    IDelinquentClaimsSummaryRecordDtoToJSON,
    IDelinquentClaimsSummaryRecordDtoToJSONTyped,
} from './IDelinquentClaimsSummaryRecordDto';

/**
 * 
 * @export
 * @interface IReportSummaryGroupDtoDelinquentClaimsSummaryRecordDto
 */
export interface IReportSummaryGroupDtoDelinquentClaimsSummaryRecordDto {
    /**
     * 
     * @type {string}
     * @memberof IReportSummaryGroupDtoDelinquentClaimsSummaryRecordDto
     */
    subsidiary_name?: string;
    /**
     * 
     * @type {Array<IDelinquentClaimsSummaryRecordDto>}
     * @memberof IReportSummaryGroupDtoDelinquentClaimsSummaryRecordDto
     */
    subsidiary_records?: Array<IDelinquentClaimsSummaryRecordDto>;
}

/**
 * Check if a given object implements the IReportSummaryGroupDtoDelinquentClaimsSummaryRecordDto interface.
 */
export function instanceOfIReportSummaryGroupDtoDelinquentClaimsSummaryRecordDto(value: object): value is IReportSummaryGroupDtoDelinquentClaimsSummaryRecordDto {
    return true;
}

export function IReportSummaryGroupDtoDelinquentClaimsSummaryRecordDtoFromJSON(json: any): IReportSummaryGroupDtoDelinquentClaimsSummaryRecordDto {
    return IReportSummaryGroupDtoDelinquentClaimsSummaryRecordDtoFromJSONTyped(json, false);
}

export function IReportSummaryGroupDtoDelinquentClaimsSummaryRecordDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IReportSummaryGroupDtoDelinquentClaimsSummaryRecordDto {
    if (json == null) {
        return json;
    }
    return {
        
        'subsidiary_name': json['subsidiary_name'] == null ? undefined : json['subsidiary_name'],
        'subsidiary_records': json['subsidiary_records'] == null ? undefined : ((json['subsidiary_records'] as Array<any>).map(IDelinquentClaimsSummaryRecordDtoFromJSON)),
    };
}

export function IReportSummaryGroupDtoDelinquentClaimsSummaryRecordDtoToJSON(json: any): IReportSummaryGroupDtoDelinquentClaimsSummaryRecordDto {
    return IReportSummaryGroupDtoDelinquentClaimsSummaryRecordDtoToJSONTyped(json, false);
}

export function IReportSummaryGroupDtoDelinquentClaimsSummaryRecordDtoToJSONTyped(value?: IReportSummaryGroupDtoDelinquentClaimsSummaryRecordDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'subsidiary_name': value['subsidiary_name'],
        'subsidiary_records': value['subsidiary_records'] == null ? undefined : ((value['subsidiary_records'] as Array<any>).map(IDelinquentClaimsSummaryRecordDtoToJSON)),
    };
}

